/**
 * One-shot cleanup of pre-P3 auth keys. Admin/mobile web sessions use HttpOnly
 * cookies (mamv_access); these keys must never be written again.
 */
const LEGACY_AUTH_KEYS = [
  'token',
  'app_token',
  'impersonator_token',
  'impersonator_user',
  'impersonation_expires_at',
];

export function clearLegacyAuthStorage() {
  for (const key of LEGACY_AUTH_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  }
}
